import {isValidIsraeliMobile, validateEmail} from '@sollapay/utils';
import {z} from 'zod';

import type {StringFieldRule} from './id-field-rules';

/** Translates `namespace:key` — pass any `useTranslation()` `t`, `common` is always loaded. */
type Translate = (key: string) => string;

const EMAIL_INVALID_KEY = 'common:fields.email.invalid';
const PHONE_INVALID_KEY = 'common:fields.phone.invalid';

/** Required + email format. Shared by buyer/signatory/team-member email fields. */
export function emailRule(t: Translate): StringFieldRule {
  return {
    required: t('common:fields.email.required'),
    validate: val => !val || !validateEmail(val) || t(EMAIL_INVALID_KEY)
  };
}

/** Required + valid Israeli mobile number. Shared by buyer/signatory phone fields. */
export function phoneRule(t: Translate): StringFieldRule {
  return {
    required: t('common:fields.phone.required'),
    validate: val => !val || isValidIsraeliMobile(val) || t(PHONE_INVALID_KEY)
  };
}

/** Zod `superRefine` counterpart of `emailRule` — a blank value is left to the `required` check. */
export function addEmailIssue(ctx: z.RefinementCtx, value: string, path = 'email'): void {
  if (value && validateEmail(value)) {
    ctx.addIssue({code: z.ZodIssueCode.custom, path: [path], message: EMAIL_INVALID_KEY});
  }
}

/** Zod `superRefine` counterpart of `phoneRule` — a blank value is left to the `required` check. */
export function addMobilePhoneIssue(ctx: z.RefinementCtx, value: string, path = 'phone'): void {
  if (value && !isValidIsraeliMobile(value)) {
    ctx.addIssue({code: z.ZodIssueCode.custom, path: [path], message: PHONE_INVALID_KEY});
  }
}
